import TextField from './text-field';
import TextArea from './text-area';
import RadioButton from './radio-button';
import CheckBox from './check-box';
import PinInput from './pin-input';
import DropDown from './drop-down';
import FileUpload from './file-upload';
const Input = {};
Input.TextField = TextField;
Input.TextArea = TextArea;
Input.RadioButton = RadioButton;
Input.CheckBox = CheckBox;
Input.PinInput = PinInput;
Input.DropDown = DropDown;
Input.FileUpload = FileUpload;
export default Input;
//# sourceMappingURL=index.js.map